import { __decorate, __metadata } from "tslib";
import { AssertionError } from "../../util/assertion-error";
import { JsonConverter, JsonObject } from "json2typescript";
let Features = class Features {
    constructor(data = {}) {
        try {
            this._data = JSON.parse(data);
        }
        catch (e) {
            this._data = data;
        }
    }
    serialize() {
        return this._data || {};
    }
    feature(key, throwOnMissing = true, defaultValueIfMissing = null) {
        if (null != this._data && key in this._data) {
            return this._data[key];
        }
        else {
            if (throwOnMissing) {
                throw new AssertionError({
                    message: `Key '${key}' was not present in the Features.`,
                    expected: "A value",
                    actual: "No value"
                });
            }
            else {
                return defaultValueIfMissing;
            }
        }
    }
};
Features = __decorate([
    JsonObject("Features"),
    __metadata("design:paramtypes", [Object])
], Features);
export { Features };
// tslint:disable-next-line: max-classes-per-file
let FeaturesConverter = class FeaturesConverter {
    serialize(data) {
        return data ? data.serialize() : null;
    }
    deserialize(val) {
        if (null == val) {
            return null;
        }
        return new Features(val);
    }
};
FeaturesConverter = __decorate([
    JsonConverter
], FeaturesConverter);
export { FeaturesConverter };
